import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=e00c2e20&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
import style0 from "./Product.vue?vue&type=style&index=0&id=e00c2e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00c2e20",
  null
  
)

export default component.exports